export const styles = theme => ({
  input: {
    marginTop: theme.spacing.unit,
    maxWidth: 300
  },
  inputContainer: {
    width: '100%'
  }
});
